import React from 'react'
import Card from '../../../../components/Card'
import Text from '../../../../components/Text'
import cx from 'classnames'
import styles from './SettingsCard.module.css'

type SettingCardProps = {
    title: string
    button: {
        title: string
        action: () => void
    }
    text: string
}

const SettingCard: React.FC<SettingCardProps> = ({ title, button, text }) => {
    return (
        <Card
            title={title}
            classes={cx(styles['setting-card'])}
            actions={[
                {
                    title: button.title,
                    onAction: button.action,
                    type: 'secondary',
                    classes: 'zr-w-100 zr-m-2',
                },
            ]}
        >
            <Text>{text}</Text>
        </Card>
    )
}

export default SettingCard
